import { type ChangeEvent, useEffect, useState } from 'react'
import { type Noop, type RefCallBack } from 'react-hook-form'

import InputFieldWithManagedState, {
  type InputFieldWithManagedStateProps,
} from './with-managed-state'

interface InputChangeEvent {
  target: EventTarget & (HTMLInputElement | HTMLTextAreaElement)
  type?: string
}

type InputChangeHandler = (event: InputChangeEvent) => Promise<void | boolean>

type ChangeHandler = (event: ChangeEvent) => void

// Combination of ControllerRenderProps and ControllerRenderProps from react-hook-form
export interface CustomFormRegister {
  ref: RefCallBack
  name: string
  value?: string | number
  onChange: InputChangeHandler | ChangeHandler | Noop
  onBlur: InputChangeHandler | Noop
}

type InputFieldWithFormRegisterProps = Pick<
  InputFieldWithManagedStateProps,
  | 'type'
  | 'label'
  | 'isRequired'
  | 'placeholder'
  | 'max'
  | 'maxLength'
  | 'autoComplete'
  | 'errorMessage'
  | 'noBorder'
  | 'borderBottom'
  | 'className'
  | 'inputClassName'
  | 'children'
  | 'onFocus'
> & {
  formRegister: CustomFormRegister
  defaultValue?: string
}

const InputFieldWithFormRegister = ({
  formRegister,
  defaultValue = '',
  type,
  label,
  isRequired,
  placeholder,
  max,
  maxLength,
  autoComplete,
  errorMessage,
  noBorder,
  borderBottom,
  className,
  inputClassName,
  children,
  onFocus,
}: InputFieldWithFormRegisterProps) => {
  const [value, setValue] = useState(defaultValue)

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  return (
    <InputFieldWithManagedState
      ref={formRegister.ref}
      type={type}
      name={formRegister.name}
      value={value}
      setValue={setValue}
      label={label}
      isRequired={isRequired}
      placeholder={placeholder}
      max={max}
      maxLength={maxLength}
      autoComplete={autoComplete}
      errorMessage={errorMessage}
      noBorder={noBorder}
      borderBottom={borderBottom}
      onChange={formRegister.onChange}
      onBlur={formRegister.onBlur}
      onFocus={onFocus}
      className={className}
      inputClassName={inputClassName}
    >
      {children}
    </InputFieldWithManagedState>
  )
}

export default InputFieldWithFormRegister
